if (!customElements.get('delegan-fit-drawer')) {
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-dsg-inline-open]');
    if (!trigger) return;
    const drawer = trigger.closest('.product-details')?.querySelector('delegan-fit-drawer');
    if (!drawer?.dialog) return;
    event.preventDefault();
    drawer.renderChart();
    drawer.dialog.showModal();
  });
  customElements.define('delegan-fit-drawer', class extends HTMLElement {
    connectedCallback() {
      if(this.initialized)return;
      this.initialized=true;
      this.dialog=this.querySelector('dialog');
      this.unit=this.dataset.country==='US'?'in':'cm';
      this.region=this.dataset.country==='US'?'US':this.dataset.country==='GB'?'UK':/^(SA|KW|QA|AE|BH|OM|JO|LB|IQ|IL|PS|YE)$/.test(this.dataset.country)?'INT':'EU';
      try{const p=JSON.parse(localStorage.getItem('delegan-size-preference')||'null');if(p&&['cm','in'].includes(p.unit))this.unit=p.unit;if(p&&['INT','EU','UK','US'].includes(p.region))this.region=p.region;}catch{}
      this.querySelector('[data-dsg-open]').addEventListener('click',e=>{e.preventDefault();this.renderChart();this.dialog.showModal();});
      this.querySelector('[data-dsg-close]').addEventListener('click',()=>this.dialog.close());
      this.dialog.addEventListener('click',e=>{if(e.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();});
      this.querySelectorAll('[data-dsg-unit]').forEach(b=>b.addEventListener('click',()=>{this.unit=b.dataset.dsgUnit;this.update();}));
      this.querySelectorAll('[data-dsg-region]').forEach(b=>b.addEventListener('click',()=>{this.region=b.dataset.dsgRegion;this.update();}));
      this.syncControls();
    }
    syncControls(){
      this.querySelectorAll('[data-dsg-region]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.dsgRegion===this.region)));
      this.querySelectorAll('[data-dsg-unit]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.dsgUnit===this.unit)));
    }
    update(){this.renderChart();try{localStorage.setItem('delegan-size-preference',JSON.stringify({unit:this.unit,region:this.region}));}catch{}}
    renderChart(){
      this.syncControls();
      const host=this.querySelector('[data-dsg-chart]');
      const source=this.querySelector('[data-dsg-source]').content;
      const rows=Array.from(source.querySelectorAll('table tr')).map(r=>Array.from(r.cells,c=>c.textContent.trim()));
      const header=rows.find(r=>r.includes('XS'));
      if(!header)return;
      const sizes=header.slice(1);
      const eu=rows.find(r=>/^(EUR?|EUROPE)\b/i.test(r[0]));
      const refs=this.region==='EU'?eu?.slice(1):this.region==='UK'?this.dataset.uk.split(',').map(s=>s.trim()):this.region==='US'?this.dataset.us.split(',').map(s=>s.trim()):null;
      const measurements=['bust','waist','hips'].map(key=>({key,row:rows.find(r=>r[0].toLowerCase().startsWith(key))})).filter(m=>m.row);
      const table=document.createElement('table');
      if(refs&&refs.some(Boolean))table.classList.add('dsg-has-reference');
      const head=table.createTHead().insertRow();
      const headings=[host.dataset.labelSize,...measurements.map(m=>host.dataset['label'+m.key[0].toUpperCase()+m.key.slice(1)]+' ('+this.unit+')')];
      if(refs&&refs.some(Boolean))headings.push(this.region);
      headings.forEach(v=>{const th=document.createElement('th');th.scope='col';th.textContent=v;head.append(th);});
      const body=table.createTBody();
      sizes.forEach((size,i)=>{
        const tr=body.insertRow();const th=document.createElement('th');th.scope='row';th.textContent=size;tr.append(th);
        measurements.forEach(m=>{const v=m.row[i+1]||'—';const td=tr.insertCell();td.textContent=this.unit==='cm'?v.replace(/\s*[-–—]\s*/g,'–'):v.replace(/\d+(?:[.,]\d+)?/g,n=>(Number(n.replace(',','.'))/2.54).toFixed(1)).replace(/\s*[-–—]\s*/g,'–');});
        if(refs&&refs.some(Boolean))tr.insertCell().textContent=refs[i]||'—';
      });
      host.replaceChildren(table);
      this.querySelectorAll('[data-dsg-unit]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.dsgUnit===this.unit)));
    }
  });
}
